const retrieveProjectSritMutations = {
    setSearchProject(state, data) {
        state.SearchProject = data;
    },
    // // 设置用户token
    // setUserToken(state, token) {
    //     state.userToken = token
    //         // 可选：同步到localStorage
    //     if (token) {
    //         localStorage.setItem('userToken', token)
    //     } else {
    //         localStorage.removeItem('userToken')
    //     }
    // },

    // 设置登录状态
    setUserLoginState(state, isLoggedIn) {
        state.isLoginState = isLoggedIn
    },
    setUserAdv(state, isAdv) {
        state.isAdv = isAdv
    },
    setNavs(state,Navs){
        state.Navs = Navs
    }
}

export default retrieveProjectSritMutations